const COMMENTABLE_TYPES = {
  profile: "Profile",
  comment: "Comment",
  missionRoleApplicant: "MissionRoleApplicant",
  missionRole: "MissionRole",
};

export default COMMENTABLE_TYPES;
